import { z } from 'zod';
import { emailBodyValidation, emailSubjectValidation } from '../../validations/sharedEmailValidations';

export const broadcastFormSchema = z.object({
    subject: emailSubjectValidation,
    body: emailBodyValidation,
    tags: z.array(
        z.object({
            name: z.string(),
            type: z.literal('pseudo').optional(),
            data: z.any().optional(),
            excluded: z.number().optional(),
        })
    ),
    excludedTags: z.array(
        z.object({
            name: z.string(),
            type: z.literal('pseudo').optional(),
            data: z.any().optional(),
            excluded: z.number().optional(),
        })
    ),
});

export type BroadcastFormData = z.infer<typeof broadcastFormSchema>;
